import { Directive, ElementRef, Input } from '@angular/core';
import { filterAllTruthyInTuple } from 'core/rx-js';
import { BehaviorSubject, combineLatest, Subject } from 'rxjs';
import { CustomizeRowFn } from './data-grid.service';

@Directive({
  selector: '[customizeRow]',
})
export class CustomizeRowDirective {
  readonly #destroy = new Subject<void>()

  readonly customizeFnSubject = new BehaviorSubject<CustomizeRowFn>(null)
  @Input('customizeRow') get customizeFn() {
    return this.customizeFnSubject.value
  }
  set customizeFn(value) {
    this.customizeFnSubject.next(value)
  }

  readonly dataSubject = new BehaviorSubject<any>(null)
  @Input('customizeRowData') get data() {
    return this.dataSubject.value
  }
  set data(value) {
    this.dataSubject.next(value)
  }

  constructor(
    private readonly _elementRef: ElementRef<HTMLElement>
  ) {

  }


  ngAfterViewInit() {

    combineLatest([this.customizeFnSubject, this.dataSubject]).pipe(
      filterAllTruthyInTuple()
    )
      .subscribe(([customizeFn, data]) => {
        customizeFn(this._elementRef.nativeElement, data)
      })
  }

  ngOnDestroy() {
    this.#destroy.next()
    this.#destroy.complete()
  }
}
